import React, { useState } from 'react'
import { Text, HStack } from 'native-base'
import { useTheme } from '../../../ThemeProvider'
import { HrItem } from '../HRItem/Index'


interface TitleItemProps {
  title: string
  subtitle?: string
  hideHR?: boolean
  blackColor?: boolean
  fontSize?: string
  icon?: {
    name: string
    size?: number
  }
}

export const TitleItem = (props: TitleItemProps) => {
  const { configEmpresa } = useTheme()
  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa)
  )

  const IconComponent = props.icon ? require('@expo/vector-icons/MaterialCommunityIcons').default : null

  return (
    <>
      <HStack space={2} alignItems="center">
        {props.icon && IconComponent && (
          <IconComponent
            name={props.icon.name}
            size={props.icon.size || 24}
            color={getConfigEmpresa.coresPWA.corFontePrimaria}
          />
        )}
        <Text
          fontSize={props.fontSize ?? 'lg'}
          style={{ color: getConfigEmpresa.coresPWA.corFontePrimaria }}
        >
          <strong>{props.title}</strong>
        </Text>
      </HStack>
      {props.subtitle && (
        <Text
          fontSize='md'
          style={{ color: getConfigEmpresa.coresPWA.corFontePrimaria }}
        >
          {props.subtitle}
        </Text>
      )}
      {props.hideHR ? null : <HrItem blackColor={props.blackColor} />}
    </>
  )
}
